import React from "react";
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import SvgIcon from "@material-ui/core/SvgIcon"
import { ReactComponent as CheckedIcon } from '../../assets/default/images/checked-icon.svg'
import { ReactComponent as UncheckedIcon } from '../../assets/default/images/unchecked-icon.svg'

interface KeepingIntouchProps {
  [key: string]: any
}

const KeepingIntouch: React.FC<KeepingIntouchProps> = (props:any) => {

  return (
    <>
      <div className="row">
        <div className="keeping-in-touch clearfix box">
          <div className="large-12 columns">
            <h2>Keeping in touch</h2>
            <p>We* would like to keep in touch with you by email. We’ll always try to personalise the emails you receive so you hear about the things which interest you most. Tick Yes below to hear from us.</p>
            <p>We may tell you about what’s on at our gardens and beyond, including events and activities, learning opportunities, membership, promotions and offers, our science and horticultural work, outreach into the community, venue hire, ways you can support our work from fundraising appeals to volunteering and our shops. We may mention partner organisations if they are collaborating with us or sponsoring events and similar activities, or to tell you about what’s going on at other visitor attractions in London and the South East. We won’t share your data with third parties for marketing purposes, so you won’t receive emails from them unless you have given us specific consent to do so.</p>
            <div className="input-container">
              <FormControlLabel
                control={
                  <Checkbox
                    disableRipple
                    onChange={props.handleChange}
                    name="optins_email"
                    id="optins_email"
                    checked={props.values.optins_email}
                    value={props.values.optins_email}
                    icon={<SvgIcon><UncheckedIcon /></SvgIcon>}
                    checkedIcon={<SvgIcon><CheckedIcon /></SvgIcon>}
                    color="primary"
                  />
                }
                label="Yes, I'm happy to receive the above marketing emails from Kew"
                labelPlacement="end"
              />
            </div>
            <p>If you don’t say yes, or you unsubscribe from this marketing at any time, please note that where you have provided your email address we will still email you about your membership, but not for any other purpose.</p>
            <p>We will also use the details you've given above to contact you by post and / or phone about Kew fundraising activities, such as fundraising appeals, invitations to fundraising events and how you may be able to leave a legacy to Kew.</p>
            <p>Please tick here if you would prefer NOT to receive these communications:</p>
            <div className="input-container">
              <FormControlLabel
                control={
                  <Checkbox
                    disableRipple
                    onChange={props.handleChange}
                    name="optins_post"
                    id="optins_post"
                    checked={props.values.optins_post}
                    value={props.values.optins_post}
                    icon={<SvgIcon><UncheckedIcon /></SvgIcon>}
                    checkedIcon={<SvgIcon><CheckedIcon /></SvgIcon>}
                    color="primary"
                  />
                }
                label="No, I do not want to be contacted by post"
                labelPlacement="end"
              />
            </div>
            <div className="input-container">
              <FormControlLabel
                control={
                  <Checkbox
                    disableRipple
                    onChange={props.handleChange}
                    name="optins_phone"
                    id="optins_phone"
                    checked={props.values.optins_phone}
                    value={props.values.optins_phone}
                    icon={<SvgIcon><UncheckedIcon /></SvgIcon>}
                    checkedIcon={<SvgIcon><CheckedIcon /></SvgIcon>}
                    color="primary"
                  />
                }
                label="No, I do not want to be contacted by phone"
                labelPlacement="end"
              />
            </div>
            <p>Please take time to read our new <a href="https://www.kew.org/about-our-organisation/our-policies/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a> which explains what data we collect and why, how we use it and other information relevant to the privacy of your data. You can change your mind about hearing from us at any time using the unsubscribe link in the footer of the emails we send you.</p>
            <p>*'We/us' refers to the Royal Botanic Gardens Kew, its wholly owned trading subsidiary RBG Kew Enterprises Limited and Kew’s charitable Foundation (responsible for legacies)</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default KeepingIntouch;